import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../i18n/LanguageContext';
import settingsService from '../../services/settings.service';

const DRAWER_WIDTH = 260;

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const [companyName, setCompanyName] = useState('ERP System');

  useEffect(() => {
    loadCompanyName();
    const handler = () => loadCompanyName();
    window.addEventListener('companySettingsUpdated', handler);
    return () => window.removeEventListener('companySettingsUpdated', handler);
  }, []);

  const loadCompanyName = async () => {
    try {
      const res = await settingsService.getCompanyName();
      if (res.data?.name) setCompanyName(res.data.name);
    } catch (err) { /* keep default */ }
  };

  return (
    <AppBar position="fixed" sx={{ width: `calc(100% - ${DRAWER_WIDTH}px)`, ml: `${DRAWER_WIDTH}px` }}>
      <Toolbar>
        <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>{companyName}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2">{t('common.welcome')}, {user?.username}</Typography>
          <Button color="inherit" startIcon={<Logout />} onClick={logout}>{t('common.logout')}</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
